export default __webpack_public_path__ + "c3a1c0ab0c369229bbcb16e649706942.svg";